import ApiFetch from 'utils/apiFetch';
import { CMS_API_URL } from 'constants/apiConf';

// Mismo endpoint público que consume el portal (portal-web-react/src/services/cmsService.ts).
// Resuelve a {CMS_API_URL}/web-cms/brand (prod: backoffice/api/web-cms/brand; dev: /cms -> /api).
// CMS brand tokens are shared with the native app; skip the PORTAL origin so the
// web reads the same values (WEB_MLS-779).
const ApiFetchInstance = ApiFetch(CMS_API_URL, { skipOrigin: true });

export const URLS = {
  brand: 'web-cms/brand',
};

export default {
  getBrand() {
    return ApiFetchInstance.get(URLS.brand);
  },
};
